// extracted by mini-css-extract-plugin
export default {"ruleTable":"ruleTable___kBoAY","ruleTitle":"ruleTitle___hSoTI","actions":"actions___RBRe3","buttons":"buttons___kJjYk","title":"title___NVLvo","enableNum":"enableNum___6zx5X"};